import { combineReducers } from "redux";
import { publishRequestsReducer } from "modules/ConfigCI/services/PublishRequests/reducer";
import { configCITestsReducer } from "modules/ConfigCI/services/ConfigCITests/reducer";
import { reportCaseReducer } from "modules/ConfigCI/services/ReportCase/reducer";

export const configCIReducer = combineReducers({
    publishRequests: publishRequestsReducer,
    configCITests: configCITestsReducer,
    reportCase: reportCaseReducer
});
